import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';
import {
  GetClientParams,
  clientsApiUrl,
} from '../../services/api/clientServices';
import { ApiResponse } from '../../services/httpService';
import { Client } from '../../models/client';
import {
  EmployeesApiUrl,
  GetEmployeesParams,
  GetSalesPersonsParams,
} from '../../services/api/employeeServices';
import { Employee } from '../../models/employee';

export const employeesService = createApi({
  reducerPath: 'employeesService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Clients', 'Employees'],
  endpoints: (builder) => ({
    getClients: builder.query<ApiResponse<Client>, GetClientParams | undefined>(
      {
        query: (params?) => ({ url: clientsApiUrl, params }),
        keepUnusedDataFor: 30,
        providesTags: ['Clients'],
      }
    ),

    getEmployees: builder.query<ApiResponse<Employee>, GetEmployeesParams>({
      query: (params) => ({ url: EmployeesApiUrl, params }),
      providesTags: (result, error, params) => [
        { type: 'Employees', role: params.role },
      ],
      keepUnusedDataFor: 30,
    }),

    getEmployee: builder.query<Employee, string>({
      query: (id) => ({ url: `${EmployeesApiUrl}/${id}` }),
      providesTags: (result, error, id) => [{ type: 'Employees', id }],
      keepUnusedDataFor: 30,
    }),

    getSalesPersons: builder.query<ApiResponse<Employee>, GetSalesPersonsParams>({
      query: (params) => ({ url: `${EmployeesApiUrl}/sales`, params }),
      providesTags: ['Employees', 'Clients'],
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetClientsQuery, useGetEmployeesQuery, useGetEmployeeQuery, useGetSalesPersonsQuery } = employeesService;
